<template>
  <div class="mb-4">
    <v-card elevation="0" style="border: 1px solid #eee; border-radius: 10px; position: relative">
      <v-card-text>
        <v-layout wrap class="form-control">
          <v-flex xs12 sm6 px-2>
            <div class="caption">Customer name</div>
            <input v-model="filterInput.customer_name" type="text" placeholder="Customer name" />
          </v-flex>
          <v-flex xs6 sm6 px-2>
            <div class="caption">คะแนนการประเมิน Q1</div>
            <multiselect
              v-model="filterInput.score_first_question"
              :options="scoreOptions"
              :searchable="false"
              select-label
              selected-label
              deselect-label
              placeholder="เลือกคะแนนการประเมิน Q1"
            ></multiselect>
          </v-flex>
          <v-flex xs6 sm6 px-2>
            <div class="caption">วันที่ส่งแบบประเมิน จาก</div>
            <DatepickerCustomDialog
              v-model="filterInput.sent_survey_date_from"
              :allowed-dates="allowedDates"
            >
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.sent_survey_date_from)"
                placeholder="Start date"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs6 sm6 px-2>
            <div class="caption">ถึง</div>
            <DatepickerCustomDialog
              v-model="filterInput.sent_survey_date_to"
              :allowed-dates="allowedDates"
            >
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.sent_survey_date_to)"
                placeholder="End date"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs6 sm6 px-2>
            <div class="caption">วันที่ตอบกลับแบบประเมิน จาก</div>
            <DatepickerCustomDialog
              v-model="filterInput.submit_survey_date_from"
              :allowed-dates="allowedDates"
            >
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.submit_survey_date_from)"
                placeholder="Start date"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs6 sm6 px-2>
            <div class="caption">ถึง</div>
            <DatepickerCustomDialog
              v-model="filterInput.submit_survey_date_to"
              :allowed-dates="allowedDates"
            >
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.submit_survey_date_to)"
                placeholder="End date"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSearch">
              <em class="fas fa-search mr-1" />
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime.js'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DatepickerCustomDialog,
    Multiselect
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filterInput: {
        customer_name: '',
        score_first_question: '',
        sent_survey_date_from: '',
        sent_survey_date_to: '',
        submit_survey_date_from: '',
        submit_survey_date_to: ''
      },
      scoreOptions: [1, 2, 3, 4, 5]
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.handleInit()
      }
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      if (this.filters) {
        this.filterInput.customer_name = this.filters.customer_name
        this.filterInput.score_first_question = this.filters.score_first_question
        this.filterInput.sent_survey_date_from = this.filters.sent_survey_date_from
        this.filterInput.sent_survey_date_to = this.filters.sent_survey_date_to
        this.filterInput.submit_survey_date_from = this.filters.submit_survey_date_from
        this.filterInput.submit_survey_date_to = this.filters.submit_survey_date_to
      }
    },
    handleSearch() {
      this.$emit('onSearch', this.filterInput)
    },
    handleClearSearch() {
      this.$emit('onClearSearch')
    },
    handleGetDateFormatted(value) {
      return value ? dayjs(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    allowedDates(val) {
      return dayjs().diff(val, 'hour', true) > 0
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/SatisfactionDetail/AdvanceSearch.vue